<span><ng-content></ng-content></span>
@if ($safeNavigationMigration(control.value?.fontId) | fontName | async; as fontName) {
  <div class="name">{{ fontName }}</div>
  <lib-button (click)="pickFont()" icon-only
    ><mat-icon>edit</mat-icon></lib-button
    >
  } @else {
    <lib-button (click)="pickFont()">Wybierz czcionkę</lib-button>
  }
